import React from 'react';
import styles from './App.module.css';
import NavBar from './components/NavBar/NavBar';
import Icons from './components/Icons/Icons';
import MailTo from './components/MailTo/MailTo'
import Landing from './components/Landing/Landing';
import Projects from './components/Projects/Projects';
import About from './components/About/About';
import EmailForm from './components/EmailForm/EmailForm';
import Hamburger from './components/Hamburger/Hamburger';
import FooterIcons from './components/FooterIcons/FooterIcons';
import JobExperience from './components/JobExperience/JobExperience';

function App() {
  return (
    <div className={styles.app}>
      <header className={styles.navBarContainer}>
        <NavBar />
      </header>
      <header className={styles.hamburgerContainer}>
        <Hamburger />
      </header>
      <main>
        <aside className={styles.iconsContainer}>
          <Icons />
        </aside>
        <aside className={styles.mailToContainer}>
          <MailTo />
        </aside>
        <section id="home" className={styles.landingContainer}>
          <Landing />
        </section>
        <section className={styles.projectsContainer}>
          <Projects />
        </section>
        <section className={styles.jobExperienceContainer}>
          <JobExperience />
        </section>
        <section id="about" className={styles.aboutContainer}>
          <About />
        </section>
        <section className={styles.emailFormContainer}>
          <EmailForm />
        </section>
      </main>
      <footer className={styles.footerIconsContainer}>
        <FooterIcons />
      </footer>
    </div >
  );
}

export default App;
